import {
  ModuleRegistry,
  ClientSideRowModelApiModule,
  TextFilterModule,
  NumberEditorModule,
  TooltipModule,
  CellStyleModule,
  RowSelectionModule,
  ValidationModule,
  TextEditorModule,
  ClientSideRowModelModule,
  RowStyleModule,
  QuickFilterModule,
  UndoRedoEditModule,
  HighlightChangesModule,
  RenderApiModule,
  RowApiModule,
} from "ag-grid-community";

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  ClientSideRowModelApiModule,
  TextFilterModule,
  NumberEditorModule,
  TooltipModule,
  CellStyleModule,
  RowSelectionModule,
  TextEditorModule,
  RowStyleModule,
  ValidationModule /* Development Only */,
  QuickFilterModule,
  UndoRedoEditModule,
  HighlightChangesModule,
  RenderApiModule,
  RowApiModule,
]);

export default function GridRegistratorProvider({ children }) {
  return children;
}
